import type { UserInfoRestrictionsWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';

const User = ({
  applicationsEnabled = false,
  paymentsAcceptedCount = false,
  paymentsAccessAllowed = false,
  loggedIn = false,
  isUserBlocked = false,
  hasAccess = false,
  hasSeenNewPaymentsPage = false,
  hasStrongAuthentication = false,
  isInitialMultiFactorAuthenticationRequired = false,
  impersonatorEmail = '',
  impersonatorUserToken = '',
  sessionExpirationDate = 0,
  sessionSecondsRemaining = 0,
  userToken = '',
  email = '',
  roles = [] as Array<string>,
  restrictions = undefined as UserInfoRestrictionsWebApiDto | undefined,
  summary = {
    activeListingCount: 0,
    totalListingCount: 0,
  },
  isMultifamilyCustomer = false,
  isRocketshipCustomerOnly = false,
  features: {
    canAccessMainMessages = false,
    canAccessAnalytics = false,
    canAccessBilling = false,
    canAccessContacts = false,
    canAccessMainAccountSettings = false,
    canAccessMainAnalytics = false,
    canAccessMainContactSupport = false,
    canAccessMainMaintenanceTracker = false,
    canAccessMainContacts = false,
    canAccessMainHelp = false,
    canAccessMainLeadManagement = false,
    canAccessMainMyProperties = false,
    canAccessMainNotificationCenter = false,
    canAccessMainPayments = false,
    canAccessMainResources = false,
    canAccessMainSecuritySettings = false,
    canAccessMessages = false,
    canAccessMultiFamilyResources = false,
    canAccessUserManagement = false,
    canAddListing = false,
    canRespondToReview = false,
    canUpdateListing = false,
    canViewOnboardingFlow = false,
  } = {},
  isEnterpriseCustomer = false,
} = {}) => ({
  applicationsEnabled: Boolean(applicationsEnabled),
  paymentsAcceptedCount: Number(paymentsAcceptedCount),
  paymentsAccessAllowed: Boolean(paymentsAccessAllowed),
  loggedIn: Boolean(loggedIn),
  isUserBlocked: Boolean(isUserBlocked),
  hasAccess: Boolean(hasAccess),
  hasSeenNewPaymentsPage: Boolean(hasSeenNewPaymentsPage),
  hasStrongAuthentication: Boolean(hasStrongAuthentication),
  isInitialMultiFactorAuthenticationRequired: Boolean(isInitialMultiFactorAuthenticationRequired),
  userToken: String(userToken),
  email: String(email),
  impersonatorEmail: String(impersonatorEmail),
  impersonatorUserToken: String(impersonatorUserToken),
  sessionExpirationDate: sessionSecondsRemaining
    ? Date.now() + sessionSecondsRemaining * 1000
    : Number(sessionExpirationDate),
  roles,
  restrictions,
  summary: Object(summary),
  isMultifamilyCustomer: Boolean(isMultifamilyCustomer),
  isRocketshipCustomerOnly: Boolean(isRocketshipCustomerOnly),
  features: {
    canAccessMainMessages: Boolean(canAccessMainMessages),
    canAccessAnalytics: Boolean(canAccessAnalytics),
    canAccessBilling: Boolean(canAccessBilling),
    canAccessContacts: Boolean(canAccessContacts),
    canAccessMainAccountSettings: Boolean(canAccessMainAccountSettings),
    canAccessMainAnalytics: Boolean(canAccessMainAnalytics),
    canAccessMainContactSupport: Boolean(canAccessMainContactSupport),
    canAccessMainMaintenanceTracker: Boolean(canAccessMainMaintenanceTracker),
    canAccessMainContacts: Boolean(canAccessMainContacts),
    canAccessMainHelp: Boolean(canAccessMainHelp),
    canAccessMainLeadManagement: Boolean(canAccessMainLeadManagement),
    canAccessMainMyProperties: Boolean(canAccessMainMyProperties),
    canAccessMainNotificationCenter: Boolean(canAccessMainNotificationCenter),
    canAccessMainPayments: Boolean(canAccessMainPayments),
    canAccessMainResources: Boolean(canAccessMainResources),
    canAccessMainSecuritySettings: Boolean(canAccessMainSecuritySettings),
    canAccessMessages: Boolean(canAccessMessages),
    canAccessMultiFamilyResources: Boolean(canAccessMultiFamilyResources),
    canAccessUserManagement: Boolean(canAccessUserManagement),
    canAddListing: Boolean(canAddListing),
    canRespondToReview: Boolean(canRespondToReview),
    canUpdateListing: Boolean(canUpdateListing),
    canViewOnboardingFlow: Boolean(canViewOnboardingFlow),
  },
  isEnterpriseCustomer: Boolean(isEnterpriseCustomer),
});

export default User;
